import { useEffect, useRef } from 'react';

const useCard = ({ isOpened }) => {
  const textRef = useRef(null);

  useEffect(() => {
    const textElement = textRef.current;
    if (!textElement) return;

    textElement.style.height = textElement.scrollHeight + 'px';
    if (isOpened) {
      const transitionEnd = () => {
        textElement.style.height = 'auto';
        textElement.removeEventListener('transitionend', transitionEnd);
      };
      textElement.addEventListener('transitionend', transitionEnd);
    } else {
      requestAnimationFrame(() => {
        textElement.style.height = '0px';
      });
    }
  }, [isOpened]);

  return { textRef };
};

export default useCard;
